import axios from 'axios';

export const getPaymentMethods = async () => {
    try {
        const response = await axios.get('https://api.childrensheart.org.kw/payment/payment-methods');
        const data = response.data.data || response.data;
        return data;
    } catch (error) {
        console.error('Error fetching payment methods:', error);
        return [];
    }
};

export const paymentMethods = []; 
